import moment from 'moment';
import { MARIAFILO, FOXTON } from './brands';

const MARIAFILO_FOXTON_CUTOFF_DATE = moment('2026-03-01');

export default (date, brandId) => {
    if ([MARIAFILO, FOXTON].includes(Number(brandId))) {
        if (moment().isSameOrAfter(MARIAFILO_FOXTON_CUTOFF_DATE, 'day')) {
            if (moment(date).isSame(moment(), 'month')) {
                return {
                    startDate: moment(date).startOf('month'),
                    endDate: moment(date).endOf('month'),
                };
            }
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }

        if (moment(date).isSame(moment('2026-02-01'), 'month')) {
            return {
                startDate: moment('2026-01-26'),
                endDate: moment('2026-02-28'),
            };
        }

        return {
            startDate: moment(date)
                .subtract(1, 'month')
                .date(26),
            endDate: moment(date).date(25),
        };
    }

    if (Number(brandId) === 16) {
        if (
            date.isBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(7)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }
        if (
            date.isSameOrBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(8)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).date(25),
            };
        }
        if (
            date.isAfter(
                moment()
                    .hour(0)
                    .date(1)
                    .month(8)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }
    } else {
        if (
            date.isBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(4)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }
        if (
            date.isSameOrBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(5)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).date(25),
            };
        }
        if (
            date.isAfter(
                moment()
                    .hour(0)
                    .date(1)
                    .month(5)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }
    }
};
